<template>
  <div>
    <h4 class="mb-4">
      Details
    </h4>
    <u-loader v-if="isLoading" />
    <template v-else>
      <div class="w-100 d-inline-block">
        <div
          v-if="
            $IsUserInRole('VertragsmanagementVerwaltung') ||
              ($IsUserInRole('VertragsmanagementUniaVertragsverantworlich') &&
              canUniaVerantwortlicheEdit === true)
          "
          class="float-right"
        >
          <button
            v-if="!editMode"
            v-b-tooltip.hover
            class="btn btn-primary mr-1"
            placement="bottom"
            title="Versionsdetails bearbeiten"
            type="button"
            @click="
              requiredProperties = [];
              editMode = !editMode;
            "
          >
            <i class="fas fa-edit" />
          </button>
          <button
            v-if="!editMode"
            v-b-modal.confirmDeleteVersion
            v-b-tooltip.hover
            class="btn btn-danger mr-4"
            placement="bottom"
            title="Diese Version löschen"
            type="button"
          >
            <i class="fas fa-trash-alt" />
          </button>
        </div>
      </div>
      <u-error-handling
        v-if="errorObject"
        :error-object="errorObject"
        :property-mapping="createErrorPropertyMappings()"
      />

      <div
        v-if="contractVersion"
        class="form-group"
      >
        <b-container class="pb-0 pt-0">
          <b-row>
            <label class="pl-0 col-3 defaultLabel">Tags</label>
            <div
              v-if="!editMode"
              class="col-9 pl-0"
            >
              <div
                v-if="
                  contractVersion &&
                    contractVersion.tagList &&
                    contractVersion.tagList.length
                "
              >
                <b-row>
                  <v-chip
                    v-for="(tag, i) in contractVersion.tagList"
                    :key="i"
                  >
                    {{ tag }}
                  </v-chip>
                </b-row>
              </div>

              <div v-else>
                -
              </div>
            </div>
            <div
              v-else
              class="col-9 pl-0"
            >
              <v-flex xs12>
                <v-combobox
                  v-if="$IsUserInRole('KonfigurationContentmanager')"
                  v-model="contractVersion.tagList"
                  :disabled="!editMode"
                  :items="itemsTags"
                  chips
                  clearable
                  deletable-chips
                  label="Tags"
                  multiple
                  @change="tagsChanged()"
                />

                <v-select
                  v-else
                  v-model="contractVersion.tagList"
                  :disabled="!editMode"
                  :items="itemsTags"
                  :menu-props="{ offsetY: true }"
                  chips
                  clearable
                  deletable-chips
                  label="Tags"
                  multiple
                />
              </v-flex>
            </div>
          </b-row>
        </b-container>
      </div>

      <div
        v-if="contractVersion"
        class="form-group"
      >
        <b-container class="pb-0 pt-0">
          <b-row>
            <label
              :for="contractVersion.versionState"
              class="pl-0 col-3 defaultLabel"
            >Version-Status</label>
            <div
              v-if="!editMode"
              class="col-9 pl-0"
            >
              <div v-if="contractVersion.versionState">
                <span>{{ versionStatusName }}</span>
              </div>
              <div v-else>
                -
              </div>
            </div>
            <div
              v-else
              class="col-9 pl-0"
            >
              <v-flex sm12>
                <v-select
                  v-model="contractVersion.versionState"
                  :items="versionStatus"
                  item-text="name"
                  item-value="id"
                  label="Version-Status"
                />
                <u-validation-checker
                  v-model="requiredProperties"
                  :is-empty="false"
                  :section="validationSection"
                  property-name="versionState"
                />
              </v-flex>
            </div>
          </b-row>
        </b-container>
      </div>

      <div
        v-if="contractVersion"
        class="form-group"
      >
        <b-container class="pb-0 pt-0">
          <b-row>
            <label
              class="pl-0 col-3 defaultLabel"
            >Verantwortung Erfassung</label>
            <div
              v-if="!editMode"
              class="col-9 pl-0"
            >
              <div v-if="contractVersion.responsableUserId">
                <span>{{ getName(contractVersion.responsableUserId) }}</span>
              </div>
              <div v-else>
                -
              </div>
            </div>
            <div
              v-else
              class="col-9 pl-0"
            >
              <v-autocomplete
                v-model="selectedUser"
                :items="allUsers"
                item-text="name"
                label="Vorname/Nachname"
                return-object
                @input="setName"
              />
            </div>
          </b-row>
        </b-container>
      </div>

      <div
        v-if="contractVersion"
        class="form-group"
      >
        <b-container class="pb-0 pt-0">
          <b-row>
            <label class="pl-0 col-3 defaultLabel">Kontrolle Erfassung</label>
            <div
              v-if="!editMode"
              class="col-9 pl-0"
            >
              <div v-if="contractVersion.controllerUserId">
                <span>{{ getName(contractVersion.controllerUserId) }}</span>
              </div>
              <div v-else>
                -
              </div>
            </div>
            <div
              v-else
              class="col-9 pl-0"
            >
              <v-autocomplete
                v-model="selectedUserController"
                :items="allUsers"
                item-text="name"
                label="Vorname/Nachname"
                return-object
                @input="setNameController"
              />
            </div>
          </b-row>
        </b-container>
      </div>
      <div
        v-if="contractVersion"
        class="form-group"
      >
        <b-container class="pb-0 pt-0">
          <b-row>
            <label
              class="pl-0 col-3 defaultLabel"
              for="versionName"
            >Name des Vertrags</label>
            <div class="col-9 pl-0">
              <div class="col-9 pl-0">
                <u-multiline-multilanguage-text-input
                  id="nameMulti"
                  v-model="contractVersion.versionContents"
                  :languages="contractVersion.translatedToLanguages"
                  :readonly="!editMode"
                  :show-all-languages="false"
                  content-property-name="value"
                />
                <u-validation-checker
                  v-if="editMode"
                  id="nameMultiChecker"
                  v-model="requiredProperties"
                  :is-empty="
                    !(
                      contractVersion.versionContents.length >=
                      contractVersion.translatedToLanguages.length
                    ) ||
                      contractVersion.versionContents.filter((content) => {
                        return (
                          translatableLanguages[content.language].selected &&
                          (content.value == '' || !content.value)
                        );
                      }).length != 0
                  "
                  :section="validationSection"
                  property-name="versionContents.value"
                />
              </div>
            </div>
          </b-row>
        </b-container>
      </div>
      <div
        v-if="contractVersion"
        class="form-group"
      >
        <b-container class="pb-0 pt-0">
          <b-row>
            <label
              class="pl-0 col-3 defaultLabel"
              for="versionShortName"
            >Kurzname</label>
            <div
              :key="contractVersion.translatedToLanguages.length"
              class="col-9 pl-0"
            >
              <u-multiline-multilanguage-text-input
                id="shortMulti"
                v-model="contractVersion.versionContents"
                :languages="contractVersion.translatedToLanguages"
                :readonly="!editMode"
                :show-all-languages="false"
                content-property-name="nameShort"
              />
              <u-validation-checker
                v-if="editMode"
                id="shortMultiChecker"
                v-model="requiredProperties"
                :is-empty="
                  !(
                    contractVersion.versionContents.length >=
                    contractVersion.translatedToLanguages.length
                  ) ||
                    contractVersion.versionContents.filter((content) => {
                      return (
                        translatableLanguages[content.language].selected &&
                        (content.nameShort == '' || !content.nameShort)
                      );
                    }).length != 0
                "
                :section="validationSection"
                property-name="versionContents.nameShort"
              />
            </div>
          </b-row>
        </b-container>
      </div>
      <div
        v-if="contractVersion"
        class="form-group"
      >
        <b-container class="pb-0 pt-0">
          <b-row>
            <label
              class="pl-0 col-3 defaultLabel"
            >Vertrag wird übersetzt in</label>
            <b-row class="col-9">
              <div class="col-6 pl-0">
                <div
                  v-for="(translatedTo, index) in translatableLanguages"
                  :key="index"
                >
                  <div class="form-check pl-0">
                    <label>
                      <input
                        v-model="translatableLanguages[index].selected"
                        :disabled="!editMode || !canDeleteLanguage"
                        :name="translatedTo.label"
                        type="checkbox"
                        @change="checkTranslateToLanguages"
                      >
                      <span class="label-text">{{ translatedTo.label }}</span>
                    </label>
                  </div>
                </div>
                <u-validation-checker
                  v-if="editMode"
                  v-model="requiredProperties"
                  :is-empty="
                    !translatableLanguages['de-CH'].selected &&
                      !translatableLanguages['fr-CH'].selected &&
                      !translatableLanguages['it-CH'].selected
                  "
                  :section="validationSection"
                  property-name="translatableLanguages"
                />
              </div>
            </b-row>
          </b-row>
        </b-container>
      </div>
      <div
        v-if="contractVersion"
        class="form-group"
      >
        <b-container class="pb-0 pt-0">
          <b-row>
            <label
              :for="contractVersion.validFrom"
              class="pl-0 col-3 defaultLabel"
            >Änderung gültig ab</label>
            <div
              v-if="!editMode && contractVersion.validFrom != null"
              class="col-9 pl-0"
            >
              <span v-if="contractVersion.validFrom">{{
                contractVersion.validFrom | moment("DD.MM.YYYY")
              }}</span>
              <span v-else>--</span>
            </div>
            <div
              v-else-if="editMode"
              class="col-9 pl-0"
            >
              <v-flex
                md6
                sm12
              >
                <u-date-picker
                  v-model="contractVersion.validFrom"
                  label="Änderung gültig ab"
                />
                <u-validation-checker
                  v-model="requiredProperties"
                  :is-empty="!contractVersion.validFrom"
                  :section="validationSection"
                  property-name="validFrom"
                />
              </v-flex>
            </div>
            <div
              v-else
              class="col-9 pl-0"
            >
              --
            </div>
          </b-row>
        </b-container>
      </div>

      <div
        v-if="contractVersion"
        class="form-group"
      >
        <b-container class="pb-0 pt-0">
          <b-row>
            <label
              :for="contractVersion.validTo"
              class="pl-0 col-3 defaultLabel"
            >Änderung gültig bis</label>
            <div
              v-if="!editMode && contractVersion.validTo != null"
              class="col-9 pl-0"
            >
              <span v-if="contractVersion.validTo">{{
                contractVersion.validTo | moment("DD.MM.YYYY")
              }}</span>
              <span v-else>--</span>
            </div>
            <div
              v-else-if="editMode"
              class="col-9 pl-0"
            >
              <v-flex
                md6
                sm12
              >
                <u-date-picker
                  v-model="contractVersion.validTo"
                  label="Laufzeit bis"
                />
                <u-validation-checker
                  v-model="requiredProperties"
                  :is-empty="!contractVersion.validTo"
                  :section="validationSection"
                  property-name="validTo"
                />
              </v-flex>
            </div>
            <div
              v-else
              class="col-9 pl-0"
            >
              --
            </div>
          </b-row>
        </b-container>
      </div>

      <div
        v-if="contractVersion && !contractVersion.anhang1"
        class="form-group"
      >
        <b-container class="pb-0 pt-0">
          <b-row>
            <label
              :for="isAVE"
              class="pl-0 col-3 defaultLabel"
            >AVE</label>
            <div class="form-check col-9 pl-0">
              <label>
                <input
                  v-model="isAVE"
                  :disabled="!editMode || !$IsUserInRole('VertragsmanagementVerwaltung')"
                  name="check"
                  type="checkbox"
                  @input="isAveChanged"
                >
                <span class="label-text" />
              </label>
              <u-validation-checker
                v-if="editMode"
                v-model="requiredProperties"
                :is-empty="false"
                :section="validationSection"
                property-name="isAVE"
              />
            </div>
          </b-row>
        </b-container>
      </div>

      <div
        v-if="contractVersion && isAVE && !contractVersion.anhang1"
        class="form-group"
      >
        <b-container class="pb-0 pt-0">
          <b-row>
            <label
              :for="contractVersion.ave.aveState"
              class="pl-0 col-3 defaultLabel"
            >AVE-Status</label>
            <div
              v-if="!editMode"
              class="col-9 pl-0"
            >
              <span>{{ aveStatusName }}</span>
            </div>
            <div
              v-else
              class="col-9 pl-0"
            >
              <v-flex sm12>
                <v-select
                  v-model="contractVersion.ave.aveState"
                  :items="aveStatus"
                  item-text="name"
                  item-value="id"
                  label="AVE-Status"
                />
                <u-validation-checker
                  v-model="requiredProperties"
                  :is-empty="false"
                  :section="validationSection"
                  property-name="ave.aveState"
                />
              </v-flex>
            </div>
          </b-row>
        </b-container>
      </div>

      <div
        v-if="contractVersion"
        class="form-group"
      >
        <b-container
          v-if="isAVE && !contractVersion.anhang1"
          class="pb-0 pt-0"
        >
          <b-row>
            <label
              :for="contractVersion.runTimeFrom"
              class="pl-0 col-3 defaultLabel"
            >AVE Änderungen gültig ab</label>

            <div
              v-if="
                !editMode &&
                  contractVersion.ave != null &&
                  contractVersion.ave.aveStart != null
              "
              class="col-9 pl-0"
            >
              <span>{{
                contractVersion.ave.aveStart | moment("DD.MM.YYYY")
              }}</span>
            </div>
            <div
              v-else-if="editMode"
              class="col-9 pl-0"
            >
              <v-flex sm12>
                <u-date-picker
                  v-model="contractVersion.ave.aveStart"
                  label="AVE Änderungen gültig ab"
                />
              </v-flex>
              <u-validation-checker
                v-model="requiredProperties"
                :is-empty="!contractVersion.ave.aveStart"
                :section="validationSection"
                property-name="ave.aveStart"
              />
            </div>
            <div
              v-else
              class="col-9 pl-0"
            >
              --
            </div>
          </b-row>
        </b-container>
      </div>

      <div
        v-if="contractVersion"
        class="form-group"
      >
        <b-container
          v-if="isAVE && !contractVersion.anhang1"
          class="pb-0 pt-0"
        >
          <b-row>
            <label
              :for="contractVersion.runTimeFrom"
              class="pl-0 col-3 defaultLabel"
            >AVE Änderungen gültig bis</label>

            <div
              v-if="
                !editMode &&
                  contractVersion.ave != null &&
                  contractVersion.ave.aveEnd != null
              "
              class="col-9 pl-0"
            >
              <span>{{
                contractVersion.ave.aveEnd | moment("DD.MM.YYYY")
              }}</span>
            </div>
            <div
              v-else-if="editMode"
              class="col-9 pl-0"
            >
              <v-flex sm12>
                <u-date-picker
                  v-model="contractVersion.ave.aveEnd"
                  label="AVE Änderungen gültig bis"
                />
              </v-flex>
              <u-validation-checker
                v-model="requiredProperties"
                :is-empty="!contractVersion.ave.aveEnd"
                :section="validationSection"
                property-name="ave.aveEnd"
              />
            </div>
            <div
              v-else
              class="col-9 pl-0"
            >
              --
            </div>
          </b-row>
        </b-container>
      </div>
      <div
        v-if="contractVersion && isAVE && !contractVersion.anhang1"
        class="form-group"
      >
        <b-container class="pb-0 pt-0">
          <b-row>
            <label
              :for="contractVersion.runTimeFrom"
              class="pl-0 col-3 defaultLabel"
            >Künstliche Verlängerung bis</label>
            <div
              v-if="!editMode"
              class="col-9 pl-0"
            >
              <span
                v-if="contractVersion.ave && contractVersion.ave.ablaufdatum"
              >{{
                contractVersion.ave.ablaufdatum | moment("DD.MM.YYYY")
              }}</span>
              <span v-else>--</span>
            </div>
            <div
              v-else-if="editMode"
              class="col-9 pl-0"
            >
              <v-flex sm12>
                <u-date-picker
                  v-model="contractVersion.ave.ablaufdatum"
                  label="Künstliche Verlängerung bis"
                />
              </v-flex>
              <u-validation-checker
                v-model="requiredProperties"
                :is-empty="!contractVersion.ave.ablaufdatum"
                :section="validationSection"
                property-name="ave.ablaufdatum"
              />
            </div>
          </b-row>
        </b-container>
      </div>

      <div
        v-if="contractVersion && !isAVE"
        class="form-group"
      >
        <b-container class="pb-0 pt-0">
          <b-row>
            <label
              :for="contractVersion.anhang1"
              class="pl-0 col-3 defaultLabel"
            >Anhang 1</label>
            <b-row class="col-9">
              <div class="form-check col-2 pl-0">
                <label>
                  <input
                    v-model="contractVersion.anhang1"
                    :disabled="!editMode || !$IsUserInRole('VertragsmanagementVerwaltung')"
                    name="check"
                    type="checkbox"
                    @change="isAnhang1Changed"
                  >
                  <span class="label-text" />
                </label>
              </div>
              <div class="col-10 pl-0">
                <span
                  v-if="contractVersion.anhang1"
                  class="defaultLabel"
                >
                  tempdata gültig ab:
                  {{ tempDataValidFrom ? tempDataValidFrom : "--" }}
                </span>
              </div>
              <u-validation-checker
                v-if="editMode"
                v-model="requiredProperties"
                :is-empty="false"
                :section="validationSection"
                property-name="anhang1"
              />
            </b-row>
          </b-row>
        </b-container>
      </div>

      <div
        v-if="contractVersion && contractVersion.anhang1 && !isAVE"
        class="form-group"
      >
        <b-container class="pb-0 pt-0">
          <b-row>
            <label
              :for="contractVersion.anhang1State"
              class="pl-0 col-3 defaultLabel"
            >Anhang1-Status</label>
            <div
              v-if="!editMode"
              class="col-9 pl-0"
            >
              <span>{{ anhang1StatusName }}</span>
            </div>
            <div
              v-else
              class="col-9 pl-0"
            >
              <v-flex sm12>
                <v-select
                  v-model="contractVersion.anhang1State"
                  :items="anhang1Status"
                  item-text="name"
                  item-value="id"
                  label="Anhang1-Status"
                />
                <u-validation-checker
                  v-model="requiredProperties"
                  :is-empty="false"
                  :section="validationSection"
                  property-name="anhang1State"
                />
              </v-flex>
            </div>
          </b-row>
        </b-container>
      </div>

      <div
        v-if="contractVersion"
        class="form-group"
      >
        <b-container
          v-if="contractVersion.anhang1 && !isAVE"
          class="pb-0 pt-0"
        >
          <b-row>
            <label class="pl-0 col-3 defaultLabel">Anhang 1 bis</label>

            <div
              v-if="!editMode"
              class="col-9 pl-0"
            >
              <span>{{
                contractVersion.anhang1ExtendedUntil | moment("DD.MM.YYYY")
              }}</span>
            </div>
            <div
              v-else-if="editMode"
              class="col-9 pl-0"
            >
              <v-flex sm12>
                <u-date-picker
                  v-model="contractVersion.anhang1ExtendedUntil"
                  label="Anhang 1 bis"
                />
              </v-flex>
              <u-validation-checker
                v-model="requiredProperties"
                :is-empty="!contractVersion.anhang1ExtendedUntil"
                :section="validationSection"
                property-name="anhang1ExtendedUntil"
              />
            </div>
            <div
              v-else
              class="col-9 pl-0"
            >
              --
            </div>
          </b-row>
        </b-container>
      </div>
      <div
        v-if="contractVersion"
        class="form-group"
      >
        <b-container class="pb-0 pt-0">
          <b-row>
            <label
              :for="contractVersion.secoId"
              class="pl-0 col-3 defaultLabel"
            >SECO-ID</label>
            <div
              v-if="!editMode"
              class="col-9 pl-0"
            >
              <span v-if="contractVersion.secoId != ''">{{
                contractVersion.secoId
              }}</span>
              <span v-else>Keine SECO-ID definiert</span>
            </div>
            <div
              v-else
              class="col-9 pl-0"
            >
              <v-flex sm12>
                <v-text-field
                  v-model="contractVersion.secoId"
                  label="SECO-ID (ABC-123-456)"
                />
                <u-validation-checker
                  v-model="requiredProperties"
                  :is-empty="!contractVersion.secoId"
                  :section="validationSection"
                  property-name="secoId"
                />
              </v-flex>
            </div>
          </b-row>
        </b-container>
      </div>
      <div
        v-if="editMode"
        class="buttonContainer pt-4"
      >
        <b-button
          :disabled="requiredProperties.length != 0"
          class
          variant="success"
          @click="saveContractVersionDetails"
        >
          Speichern
        </b-button>
        <b-button
          class="ml-2"
          variant="danger"
          @click="reloadContractVersionDetails()"
        >
          Abbrechen
        </b-button>
      </div>

      <b-modal
        id="confirmDeleteVersion"
        ref="confirmDeleteVersion"
        hide-footer
        no-fade
        title="Version löschen"
      >
        <u-loader
          v-if="versionDeleting"
          text="Version wird gelöscht. Das kann eine Weile dauern..."
        />
        <template v-else>
          <div class="d-block mb-4">
            Sind Sie sicher, dass Sie diese Version löschen möchten?

            <b-alert
              :show="
                $store.state.adminCurrentContract.Editions.filter((edition) => {
                  return edition.stateId == 3;
                }).length > 0
              "
              class="mt-4"
              variant="danger"
            >
              <b>Achtung: </b>Diese Version enthält eine aktualisierte Edition.
            </b-alert>
          </div>
          <b-button
            variant="success"
            @click="deleteVersion()"
          >
            Ok
          </b-button>
          <b-button
            class="ml-2"
            variant
            @click="hideModal"
          >
            Abbrechen
          </b-button>
        </template>
      </b-modal>

      <b-modal
        id="confirmDeleteLanguage"
        ref="confirmDeleteLanguage"
        hide-footer
        no-fade
        title="Sprache deaktivieren"
      >
        <div class="d-block mb-4">
          Sind Sie sicher, dass Sie die Sprache deaktivieren wollen? Es werden
          alle Übersetzungen gelöscht und müssen danach neu erfasst werden.
        </div>
        <b-button
          variant="success"
          @click="updateTranslateToLanguages()"
        >
          Ok
        </b-button>
        <b-button
          class="ml-2"
          variant
          @click="reloadContractVersionDetails()"
        >
          Abbrechen
        </b-button>
      </b-modal>

      <b-modal
        id="warnigTranslationChanged"
        ref="warnigTranslationChanged"
        hide-footer
        no-fade
        title="Verfügbare Sprachen geändert"
      >
        <template>
          <div class="d-block mb-4">
            Sie haben die verfügbaren Sprachen geändert. Bitte bearbeiten Sie
            die Übersetzungen in der Edition.
          </div>
          <b-button
            variant="success"
            @click="hideTranslationWarnig()"
          >
            Ok
          </b-button>
        </template>
      </b-modal>
    </template>
  </div>
</template>

<script>
import { de } from "vuejs-datepicker/dist/locale";
import UDatePicker from "@/components/common/UDatePicker.vue";
import moment from "moment";
import {
  GetAllPublications,
  GetAvailableTenants,
} from "@/services/contract.tenants.service.js";
import { GetAllUsers } from "@/services/user.service.js";

import {
  GetVersionInformation,
  SaveVersionInformation,
  DeleteContractVersion,
  GetVersionStatus,
  GetAnhang1Status,
  GetAveStatus,
  GetVersionTags,
} from "@/services/contract.service.js";

import { GetAllEditions } from "@/services/contract.edition.service.js";

export default {
  components: {
    UDatePicker,
  },
  props: {
    contractId: {
      type: String,
      default: "",
    },
    versionId: {
      type: Number,
      default: 0,
    },
    versionIdId: {
      type: Number,
      default: 0,
    },
    selectedLanguages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      validationSection: "Version",
      contractVersion: null,
      isLoading: false,
      errorObject: null,
      editMode: false,
      versionDeleting: false,

      requiredProperties: [],
      de: de,
      translatableLanguages: {
        "de-CH": { language: "de-CH", label: "Deutsch", selected: false },
        "fr-CH": { language: "fr-CH", label: "Französisch", selected: false },
        "it-CH": { language: "it-CH", label: "Italienisch", selected: false },
      },
      originalTranslatableLanguages: {
        "de-CH": { language: "de-CH", label: "Deutsch", selected: false },
        "fr-CH": { language: "fr-CH", label: "Französisch", selected: false },
        "it-CH": { language: "it-CH", label: "Italienisch", selected: false },
      },
      isAVE: null,
      tempDataValidFrom: null,
      selectedUser: null,
      selectedUserController: null,
      allUsers: [],
      versionStatus: [],
      aveStatus: [],
      anhang1Status: [],
      itemsTags: [],
      originalLanguages: {},
      canDeleteLanguage: true,
      canSaveVersion: true,
    };
  },
  computed: {
    versionStatusName() {
      var versionToShow = this.versionStatus.find((element) => {
        return element.id == this.contractVersion.versionState;
      });

      if (versionToShow) {
        return versionToShow.name;
      } else {
        return "";
      }
    },
    aveStatusName() {
      var versionToShow = this.aveStatus.find((element) => {
        return element.id == this.contractVersion.ave.aveState;
      });

      if (versionToShow) {
        return versionToShow.name;
      } else {
        return "";
      }
    },
    canUniaVerantwortlicheEdit() {
      if (this.$store.state.adminCurrentContract.VersionData?.ave) {
        if (
          this.$store.state.adminCurrentContract.VersionData.ave.aveState != 0
        ) {
          return false;
        } else if (
          this.$store.state.adminCurrentContract.VersionData.ave.aveState ==
            0 &&
          this.$store.state.adminCurrentContract.VersionData.anhang1 === true
        ) {
          return false;
        } else if (
          this.$store.state.adminCurrentContract.VersionData.ave.aveState ==
            0 &&
          this.$store.state.adminCurrentContract.VersionData.anhang1 === false
        ) {
          return true;
        }
      }

      if (!this.$store.state.adminCurrentContract.VersionData) {
        return true;
      }
      if (!this.$store.state.adminCurrentContract.VersionData.ave) {
        if (
          this.$store.state.adminCurrentContract.VersionData.anhang1 === true
        ) {
          return false;
        } else if (
          this.$store.state.adminCurrentContract.VersionData.anhang1 === false
        ) {
          return true;
        }
      }

      return false;
    },

    anhang1StatusName() {
      var versionToShow = this.anhang1Status.find((element) => {
        return element.id == this.contractVersion.anhang1State;
      });

      if (versionToShow) {
        return versionToShow.name;
      } else {
        return "";
      }
    },
  },
  watch: {
    translatableLanguages: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit("translatableLanguagesChanged", newValue);
        }
      },
      deep: true,
    },
  },

  created() {
    this.isLoading = true;
    Promise.all([
      this.getContractTags(),
      this.loadContractVersionDetails(),
      this.loadAllUsers(),
      this.LoadAllEditions(),
    ])
      .then(() => {
        this.isLoading = false;
      })
      .catch((error) => {
        this.errorObject = error;
      });
  },
  methods: {
    hideTranslationWarnig() {
      this.$refs.warnigTranslationChanged.hide();
      this.canSaveVersion = true;
      this.saveVersionInformation();
    },
    saveVersionInformation() {
      SaveVersionInformation(
        this.contractVersion,
        this.contractId,
        this.versionId,
        () => {
          location.reload();
          this.editMode = false;
        },
        (error) => {
          this.errorObject = error;
        },
      );
    },
    LoadAllEditions() {
      GetAllEditions(
        this.contractId,
        this.versionId,
        (response) => {
          if (response && response.length) {
            if (
              response.some((editionObject) => {
                return editionObject.stateId !== 1;
              })
            ) {
              this.canDeleteLanguage = false;
            }
          }
        },
        (error) => {
          this.errorObject = error;
        },
      );
    },
    tagsChanged() {
      if (
        this.contractVersion &&
        this.contractVersion.tagList &&
        this.contractVersion.tagList.length > 1
      ) {
        this.contractVersion.tagList.forEach((value) => {
          if (this.itemsTags.indexOf(value) === -1) {
            this.itemsTags.push(value);
          }
        });
      } else {
        if (this.contractVersion.tagList[0]) {
          this.itemsTags.push(this.contractVersion.tagList[0]);
        }
      }
    },
    getContractTags() {
      GetVersionTags(
        (response) => {
          if (response.data.length) {
            response.data.forEach((tag) => {
              this.itemsTags.push(tag.tagName);
            });
          }
        },
        (error) => {
          this.errorObject = error;
        },
      );
    },
    setName(value) {
      if (value) {
        this.contractVersion.responsableUserId = value.id;
        this.selectedUser = value;
      }
    },
    setNameController(value) {
      if (value) {
        if (this.selectedUserController) {
          this.selectedUserController = value;
        }

        if ("id" in value) {
          if (
            this.contractVersion &&
            "controllerUserId" in this.contractVersion
          ) {
            this.contractVersion.controllerUserId = value.id;
          }
        }
      }
    },
    getName(userId) {
      if (userId) {
        if (this.allUsers && this.allUsers.length) {
          return this.allUsers.find((user) => user.id == userId).name;
        }
      }
    },
    loadAllUsers() {
      this.errorObject = null;

      GetAllUsers(
        (response) => {
          let counter = 0;
          if (response) {
            this.allUsers.push({
              id: null,
              name: "",
            });
            response.forEach((user) => {
              this.allUsers.push({
                id: user.id,
                name: user.firstName + " " + user.lastName,
              });
              counter++;
            });

            if (counter == response.length) {
              if (this.contractVersion) {
                if ("responsableUserId" in this.contractVersion) {
                  if (this.contractVersion.responsableUserId) {
                    this.selectedUser = this.allUsers.find(
                      (user) =>
                        user.id == this.contractVersion.responsableUserId,
                    );
                  }
                }

                if ("controllerUserId" in this.contractVersion) {
                  if (this.contractVersion.controllerUserId) {
                    this.selectedUserController = this.allUsers.find(
                      (user) =>
                        user.id == this.contractVersion.controllerUserId,
                    );
                  }
                }
              }
            }
          }
        },
        (error) => {
          this.errorObject = error;
        },
      );
    },
    loadTempDataValidFrom() {
      GetAvailableTenants(
        (response) => {
          var tempDataTenant = response.filter((tenant) => {
            return (
              tenant.bezeichnung == this.$UniaGAVConstants.tempDataTenantName
            );
          });

          var that = this;

          if (tempDataTenant.length == 1) {
            GetAllPublications(
              this.contractId,
              this.versionIdId,
              (response) => {
                var tempDataPublication = response.filter((publication) => {
                  return publication.tenantId == tempDataTenant[0].id;
                });

                if (
                  tempDataPublication.length == 1 &&
                  tempDataPublication[0].validFrom
                ) {
                  that.tempDataValidFrom = that
                    .$moment(tempDataPublication[0].validFrom)
                    .format("DD.MM.YYYY");
                }
              },
              () => {},
            );
          }
        },
        () => {},
      );
    },
    aveEndDateChanged(newDate) {
      var testObject = moment(newDate).add(30, "days");
      this.contractVersion.ave.ablaufdatum = testObject.format("YYYY-MM-DD");
    },
    createErrorPropertyMappings() {
      var mapping = {};
      mapping["Ave.AveEnd"] = "AVE Änderungen gültig ab";
      mapping["Ave.AveStart"] = "AVE Änderungen gültig bis";
      mapping["Ave.Ablaufdatum"] = "Künstliche Verlängerung bis";

      return mapping;
    },
    isAnhang1Changed() {
      if (!this.contractVersion.anhang1) {
        this.contractVersion.anhang1State = 0;
      }
    },
    isAveChanged() {
      this.isAVE = !this.isAVE;
      if (this.isAVE && this.contractVersion.ave == null) {
        this.contractVersion.ave = {
          aveStart: "",
          aveEnd: "",
          ablaufdatum: "",
          aveState: 0,
        };
      }

      if (!this.isAVE) {
        this.contractVersion.ave.aveState = 0;
        this.contractVersion.ave.aveStart = "";
        this.contractVersion.ave.aveEnd = "";
        this.contractVersion.ave.ablaufdatum = "";
      }
    },
    loadContractVersionDetails() {
      var that = this;
      this.errorObject = null;

      GetVersionStatus(
        (result) => {
          for (var property in result.data) {
            that.versionStatus.push({
              id: parseInt(property),
              name: result.data[property],
            });
          }
        },
        (error) => {
          that.errorObject = error;
        },
      );
      GetAnhang1Status(
        (result) => {
          for (var property in result.data) {
            that.anhang1Status.push({
              id: parseInt(property),
              name: result.data[property],
            });
          }
        },
        (error) => {
          that.errorObject = error;
        },
      );
      GetAveStatus(
        (result) => {
          for (var property in result.data) {
            that.aveStatus.push({
              id: parseInt(property),
              name: result.data[property],
            });
          }
        },
        (error) => {
          that.errorObject = error;
        },
      );

      GetVersionInformation(
        this.contractId,
        this.versionId,
        (result) => {
          this.contractVersion = result;

          this.$store.commit("setAdminCurrentContractVersion", result.number);

          this.$store.commit("setAdminCurrentContractVersionId", result.id);

          that.resetTranslatedLanguage();

          if (that.contractVersion.translatedToLanguages.length > 0) {
            let countTransLang = 0;
            for (
              var i = 0;
              i < that.contractVersion.translatedToLanguages.length;
              i++
            ) {
              var transLanguage = that.contractVersion.translatedToLanguages[i];
              that.translatableLanguages[transLanguage.language].selected =
                true;
              countTransLang++;
            }

            if (
              countTransLang ===
              that.contractVersion.translatedToLanguages.length
            ) {
              this.$emit(
                "translatableLanguagesChanged",
                that.translatableLanguages,
              );
            }
          } else if (that.translatableLanguages["de-CH"]) {
            that.translatableLanguages["de-CH"].selected = true;
            this.contractVersion.translatedToLanguages = [
              { language: "de-CH" },
            ];
          }

          that.originalTranslatableLanguages = JSON.parse(
            JSON.stringify(that.translatableLanguages),
          );

          this.originalLanguages = JSON.parse(
            JSON.stringify(this.contractVersion.translatedToLanguages),
          );

          if (this.contractVersion.ave != null) {
            if (this.contractVersion.ave.aveState > 0) {
              this.isAVE = true;
            } else {
              this.isAVE = false;
            }
          } else {
            this.isAVE = false;
            this.contractVersion.ave = {
              aveStart: "",
              aveEnd: "",
              ablaufdatum: "",
            };
          }
        },
        (error) => {
          this.errorObject = error;
        },
      );

      this.loadTempDataValidFrom();
    },

    hideModal() {
      this.$refs["confirmDeleteVersion"].hide();
    },
    deleteVersion() {
      this.versionDeleting = true;
      this.errorObject = null;

      DeleteContractVersion(
        this.contractId,
        this.versionId,
        () => {
          this.versionDeleting = false;
          this.$emit("VersionDeleted", this.versionId);
          this.hideModal();
        },
        (error) => {
          this.versionDeleting = false;
          this.errorObject = error;
          this.hideModal();
        },
      );
    },
    checkTranslateToLanguages() {
      let deselectedCounter = 0;

      if (this.originalTranslatableLanguages["de-CH"].selected) {
        if (!this.translatableLanguages["de-CH"].selected) {
          deselectedCounter++;
        }
      }

      if (this.originalTranslatableLanguages["fr-CH"].selected) {
        if (!this.translatableLanguages["fr-CH"].selected) {
          deselectedCounter++;
        }
      }

      if (this.originalTranslatableLanguages["it-CH"].selected) {
        if (!this.translatableLanguages["it-CH"].selected) {
          deselectedCounter++;
        }
      }

      if (deselectedCounter >= 1) {
        this.$refs.confirmDeleteLanguage.show();
      } else {
        this.updateTranslateToLanguages();
      }
    },
    updateTranslateToLanguages() {
      this.isLoading = true;
      this.contractVersion.translatedToLanguages = [];
      this.requiredProperties.push({ test: "nothing" });
      for (var lang in this.translatableLanguages) {
        if (this.translatableLanguages[lang].selected) {
          this.contractVersion.translatedToLanguages.push({ language: lang });

          if (
            this.contractVersion.versionContents.filter((content) => {
              return content.language === lang;
            }).length === 0
          ) {
            this.contractVersion.versionContents.push({
              versionId: this.versionId,
              language: lang,
              value: "",
              nameShort: "",
            });
          }
        }
      }

      setTimeout(() => {
        // this is a hack, because changing the collection triggers all validation component to check if the field is still empty or not
        this.requiredProperties.splice(this.requiredProperties.length - 1, 1);
        this.isLoading = false;
      }, 100);
    },
    saveContractVersionDetails() {
      // First, we have to format all Dates (somehow, this is necessary if the Time is not 00:00:00, dont know why that is...)
      this.contractVersion.validFrom = this.contractVersion.validFrom
        ? this.$moment(this.contractVersion.validFrom).format("YYYY-MM-DD")
        : "";
      this.contractVersion.validTo = this.contractVersion.validTo
        ? this.$moment(this.contractVersion.validTo).format("YYYY-MM-DD")
        : "";

      this.errorObject = null;

      var contents = JSON.parse(
        JSON.stringify(this.contractVersion.versionContents),
      );
      this.contractVersion.versionContents = [];

      if (
        this.originalLanguages.length <
        this.contractVersion.translatedToLanguages.length
      ) {
        this.canSaveVersion = false;
        this.$refs.warnigTranslationChanged.show();
      }
      this.originalLanguages = JSON.parse(
        JSON.stringify(this.contractVersion.translatedToLanguages),
      );

      this.contractVersion.translatedToLanguages.map((language) => {
        var conentToAdd = contents.filter((content) => {
          return content.language == language.language;
        });

        if (conentToAdd.length > 0) {
          this.contractVersion.versionContents.push(
            JSON.parse(JSON.stringify(conentToAdd[0])),
          );
        }
      });

      if (!this.isAVE && this.contractVersion.ave != null) {
        this.contractVersion.ave.aveStart = "";
        this.contractVersion.ave.aveEnd = "";
        this.contractVersion.ave.ablaufdatum = "";
      }

      if (this.contractVersion.ave.aveState > 0) {
        this.isAVE = true;
      } else {
        this.isAVE = false;
      }

      if (this.canSaveVersion) {
        this.saveVersionInformation();
      }
    },
    reloadContractVersionDetails() {
      this.$refs.confirmDeleteLanguage.hide();
      this.loadContractVersionDetails();
      this.editMode = false;
    },
    resetTranslatedLanguage() {
      for (var lang in this.translatableLanguages) {
        this.translatableLanguages[lang].selected = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
